import {AbstractLitElement} from "../abstract-lit.element";
import {property} from "lit/decorators/property.js";
import {html, PropertyValues} from "lit";
import {container} from "tsyringe";
import {DynamicLoadHandler} from "../../dynamic-loading/dynamic-load-handler.interface";
import {map} from "lit/directives/map.js";
import {customElement} from "lit/decorators/custom-element.js";
import {StringHelper} from "../../helpers/string.helper";
import {classMap} from "lit/directives/class-map.js";
import {state} from "lit/decorators/state.js";
import {ArrayHelper} from "../../helpers/array.helper";

@customElement(`ha-dynamic-load`)
export class HaDynamicLoadComponent extends AbstractLitElement {

    @property({type: Object})
    public component: AbstractLitElement | null = null;

    @property({type: Object})
    public options!: Record<string, any>

    @property({type: String})
    public key!: string;

    private _handlers: DynamicLoadHandler[] = [];

    @state()
    private _handlersByOptions: DynamicLoadHandler[] = [];

    protected willUpdate(changedProperties: PropertyValues): void {
        if (changedProperties.has(`key`) && changedProperties.get(`key`) !== this.key) {
            this._handlers = container.resolveAll<DynamicLoadHandler>(this.key);
        }

        if (changedProperties.has(`options`) && this.options) {
            ArrayHelper.filterAsync<DynamicLoadHandler>(
                this._handlers,
                handler => (typeof handler.filter === "function")
                    ? handler.filter(this.options)
                    : Promise.resolve(true)
            ).then(handlers => this._handlersByOptions = handlers);
        }
    }

    protected render(): unknown {
        const handlers = this._handlersByOptions;

        return map(handlers, handler => {
            const cssClasses = {
                "plugin-container": true,
                [`plugin__${StringHelper.toKebabCase(handler.constructor.name)}`]: true,
            };

            return html`
                <div class=${classMap(cssClasses)}>
                    ${handler.render(this.component!, this.options)}
                </div>
            `
        });
    }
}